import { apiClient } from "../../services/api";

// const active_filtro = localStorage.getItem("@socialcam/active_filtro")
//TODO: create state to manage aproved colabs to be exibited
const state = () => ({
  colaboracoes: {
    colaboracoes_recebidas: null,
    colaboracoes_favoritas: null,
    colaboracoes_exibidas: null,
    colaboracoes_em_pasta: null,
  },
  copy_colaboracoes_recebidas: null,
  filtros_redes_sociais: null,
  filtros_titulo_live: null,
  active_filtro: false,
  cod_producao: null,
});


const getters = {
  colaboracoes: state => {
    return state.colaboracoes
  },
  filtros_redes_sociais: state => {
    return state.filtros_redes_sociais;
  },
  filtros_titulo_live: state => {
    return state.filtros_titulo_live;
  },
  active_filtro: state => {
    return state.active_filtro
  },
  cod_producao: state => {
    return state.cod_producao
  },
  getCopyColaboracoesRecebidas: state => {
    return state.copy_colaboracoes_recebidas;
  }
};

const actions = {
  async getColaboracoesAprovadas({ commit, rootState }, payload) {
    let {
      page = 1,
      size = 5,
      cod_producao,
      flg_favorita,
      filtros,
      filtro_texto,
      filtros_por_tipo_de_media,
      filtro_por_live,
      flg_exibida,
      cod_pasta
    } = payload;
    try {
      const localFiltro = localStorage.getItem("@socialcam/filtros") || ""
      const localFiltroLive = localStorage.getItem("@socialcam/filtros_por_live") || ""
      // const localFlgFavorita = JSON.parse(localStorage.getItem("@socialcam/flg_favorita")) || false
      const localFiltroTexto = localStorage.getItem("@socialcam/filtro_texto") || ""
      const localFiltrosPorTipoDeMedia = localStorage.getItem("@socialcam/filtros_por_tipo_de_media") || ""

      if (localFiltro !== undefined && localFiltro !== null) {
        filtros = localFiltro;
      }

      if (localFiltroLive !== undefined && localFiltro !== null) {
        filtro_por_live = localFiltroLive;
      }

      if (localFiltrosPorTipoDeMedia !== undefined && localFiltro !== null) {
        filtros_por_tipo_de_media = localFiltrosPorTipoDeMedia;
      }

      if (localFiltroTexto !== undefined && localFiltroTexto !== null) {
        filtro_texto = localFiltroTexto;
      }
      
      let filtro_por_live_formatado = []

      if (filtro_por_live && filtro_por_live.trim() !== "") {
        try {
          let parsed = JSON.parse(filtro_por_live);

          // Garante que parsed NUNCA seja array dentro de outro array
          if (Array.isArray(parsed) && Array.isArray(parsed[0])) {
            parsed = parsed[0];
          }

          // Se não for array, vira array
          if (!Array.isArray(parsed)) {
            parsed = [parsed];
          }

          // Codifica cada item
          const encoded = parsed.map(item => encodeURIComponent(item));

          // JSON final correto
          filtro_por_live_formatado = JSON.stringify(encoded);

        } catch (e) {
          // Quando vem no formato errado ex.: [SÃO JOSÉ...]
          const cleaned = filtro_por_live.replace(/^\[|\]$/g, "").trim();

          filtro_por_live_formatado = JSON.stringify([
            encodeURIComponent(cleaned)
          ]);
        }
      }

      const { data } = await apiClient.get(
        `/listarColaboracoesProducao/${cod_producao}?page=${page}&size=${size}&flg_favorita=${flg_favorita}&filtros_por_tipo_de_media=${filtros_por_tipo_de_media}&filtros=${filtros}&filtro_texto=${filtro_texto === "null" ? "" : filtro_texto
        }&flg_exibida=${flg_exibida}&cod_pasta=${cod_pasta ? cod_pasta : 0}&filtro_por_live=${filtro_por_live_formatado}`
      );

      const key = cod_pasta && cod_pasta != 0 ? 'colaboracoes_em_pasta' : flg_exibida ? 'colaboracoes_exibidas' : flg_favorita ? 'colaboracoes_favoritas' : 'colaboracoes_recebidas'


      commit("setColaboracoes", { data: data.colaboracoes, key });

      // Only update if num_inscritos_youtube actually changed to avoid infinite loop
      // (updateSelectedProducao creates a new object, triggering all watchers again)
      if (data.num_inscritos_youtube !== undefined) {
        const currentValue = rootState.producoes.selectedProducao?.num_inscritos_youtube;
        if (currentValue !== data.num_inscritos_youtube) {
          commit("producoes/updateSelectedProducao", { num_inscritos_youtube: data.num_inscritos_youtube }, { root: true });
        }
      }
    } catch (error) {
      return error
    }
  },
  async getColaboracoesFiltrosRedesSociais({ commit }, payload) {
    try {
      let { cod_producao } = payload
      
      const { data } = await apiClient.get(
        `filtrosMidiasSociais/${cod_producao}`
      )
      
      commit('setColaboracoesFiltrosRedesSociais', data.filtros)
    } catch (error) {
      console.error(error)
    }
  },
  async getFiltrosLive({ commit }, payload) {
    try {
      let { cod_producao } = payload

      const {data} = await apiClient.get(`filtrosPorTituloLive/${cod_producao}`)

      const filtro_in_local_storage = JSON.parse(localStorage.getItem("@socialcam/filtros_por_live")) || []

      const filtro_in_db = new Set(data.filtros_live.map(item => item.dsc_titulo_live_chat));

      filtro_in_local_storage.filter(value => !filtro_in_db.has(value));

      const updated_filtro_in_local_storage = filtro_in_local_storage.filter(value => filtro_in_db.has(value));

      localStorage.setItem("@socialcam/filtros_por_live", JSON.stringify(updated_filtro_in_local_storage));

      commit('setColaboracoesFiltrosLive', data.filtros_live)   
    } catch (error) {
      console.error(error)
    }
  },
  changeIfFiltroIsActive({ commit }, payload) {
    commit("setIfFiltroIsActive", payload)
  },
  changeCodProducao({ commit }, payload) {
    commit("setCodProducao", payload)
  },
  incrementTotalItemsFavoritas({ commit }, payload) {
    const { flg_favorita } = payload

    if (flg_favorita) {
      commit("incrementTotalItemsFavoritas", +1)
    } else {
      commit("incrementTotalItemsFavoritas", -1)
    }
  },
  incrementTotalItemsExibidas({ commit }, payload) {
    const { value } = payload
    commit("incrementTotalItemsExibidas", value)
  },
  zerarTotalItems({ commit }, payload) {
    const { totalItems, flg_favorita_ou_exibida } = payload

    if (flg_favorita_ou_exibida === 'flg_favorita') {
      commit("incrementTotalItemsFavoritas", -totalItems)
    } else {

      commit("incrementTotalItemsExibidas", -totalItems)
    }
  },
  setCopyColaboracoesRecebidas({ commit }, value) {
    try {
      commit('setCopyColaboracoesRecebidas', value)
    } catch (error) {
      console.error(error)
      return error
    }
  }
};

const mutations = {
  setColaboracoes(state, payload) {
    const { data, key } = payload
    state.colaboracoes[key] = data
  },
  setColaboracoesFiltrosRedesSociais(state, payload) {
    state.filtros_redes_sociais = payload
  },
  setColaboracoesFiltrosLive(state, payload) {
    state.filtros_titulo_live = payload
  },
  setIfFiltroIsActive(state, payload) {
    state.active_filtro = payload
  },
  setCodProducao(state, payload) {
    state.cod_producao = payload
  },
  incrementTotalItemsFavoritas(state, payload) {
    state.colaboracoes.colaboracoes_favoritas.totalItems = state.colaboracoes.colaboracoes_favoritas.totalItems + payload
  },
  incrementTotalItemsExibidas(state, payload) {
    state.colaboracoes.colaboracoes_exibidas.totalItems = state.colaboracoes.colaboracoes_exibidas.totalItems + payload
  },
  setCopyColaboracoesRecebidas(state, value) {
    state.copy_colaboracoes_recebidas = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
